// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2MLYz","comment":"styles_comment__2MsXx"};